/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notifier__notification--success{background-color:#5cb85c;color:#fff}.notifier__notification--success .notifier__notification-button-icon{fill:#fff}"];
export { styles as styles };
